
import React, { useState } from "react";
import { QuizQuestion } from "@/types";
import QuizQuestionComponent from "./QuizQuestion";
import QuizControls from "./QuizControls";

interface QuizProps {
  questions: QuizQuestion[];
  onFinish: (answers: Record<string, string>) => void;
}

const Quiz: React.FC<QuizProps> = ({ questions, onFinish }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<Record<string, string>>({});

  const currentQuestion = questions[currentQuestionIndex];
  const totalQuestions = questions.length;
  const isFirstQuestion = currentQuestionIndex === 0;
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;

  const handleSelectOption = (optionId: string) => {
    setAnswers({
      ...answers,
      [currentQuestion.id]: optionId,
    });
  };

  const handlePrevious = () => {
    if (!isFirstQuestion) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleNext = () => {
    if (!isLastQuestion) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      onFinish(answers);
    }
  };

  const isCurrentQuestionAnswered = !!answers[currentQuestion.id];

  return (
    <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
      <div className="mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-techne-blue mb-2">
          Board AI Governance Readiness Assessment
        </h2>
        <p className="text-gray-600">
          Answer the following questions to evaluate your board's AI governance readiness.
        </p>
      </div>

      <QuizQuestionComponent
        question={currentQuestion}
        selectedOption={answers[currentQuestion.id] || null}
        onSelectOption={handleSelectOption}
        questionNumber={currentQuestionIndex + 1}
        totalQuestions={totalQuestions}
      />

      <QuizControls
        onPrevious={handlePrevious}
        onNext={handleNext}
        isFirstQuestion={isFirstQuestion}
        isLastQuestion={isLastQuestion}
        isCurrentQuestionAnswered={isCurrentQuestionAnswered}
      />
    </div>
  );
};

export default Quiz;
